
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapGetters } from 'vuex';
import CurrentWeatherBar from '@/components/CurrentWeatherBar.vue';
import SearchWeatherBar from '@/components/SearchWeatherBar.vue';
import AdvancedWeatherDetails from '@/components/AdvancedWeatherDetails.vue';
import { Place } from '@/store/weather/types';

@Options({
  components: { CurrentWeatherBar, SearchWeatherBar, AdvancedWeatherDetails },
  methods: { ...mapActions(['getWeatherByPlace']) },
  computed: { ...mapGetters(['getCurrentPlace']) },
})
export default class HomePage extends Vue {
  showSearchBar = false;

  getWeatherByPlace!: (place: Place) => void;

  getCurrentPlace!: Place;

  handleShowSearchBar() {
    this.showSearchBar = true;
  }

  handleCloseSearchBar() {
    this.showSearchBar = false;
  }

  mounted() {
    this.getWeatherByPlace(this.getCurrentPlace);
  }
}
